/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="giftCardTypes.module.ts" />

module Meevo.Plugins.GiftCardTypes {
    class GiftCardTypesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

      static $inject = [
        "meevo.AppSettings",
        "meevo.components.common.DataService",
        "meevo.components.modal.ModalService",
        "meevo.components.common.IdentityService",
        "meevo.components.logging.LoggingService",
        "meevo.components.common.SecurityService",
        "meevo.components.tracking.TrackingService",
        "$rootScope",
        "$scope",
        "$state",
        "meevo.ContextParams",
        'meevo.components.short-cuts.ShortCutsService',

        "meevo.components.busy.BusyService",
        "$translate"];

      constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
        protected dataService: Meevo.Components.BaseClasses.IDataService,
        protected modalService: Meevo.Components.Modal.IModalService,
        protected identityService: Meevo.Components.Common.IIdentityService,
        protected loggingService: Meevo.Components.Logging.ILoggingService,
        protected securityService: Meevo.Components.Common.ISecurityService,
        protected trackingService: Meevo.Components.Tracking.ITrackingService,
        protected $rootScope: angular.IRootScopeService,
        protected $scope: angular.IScope,
        protected $state: any,
        protected contextParams: Meevo.IContextParams,
        protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

        protected busyService: Meevo.Components.Busy.IBusyService,
        protected $translate: angular.translate.ITranslateService) {

          super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

      }

      /**
     * Creates the context for editing/adding an item.
     * @return {}
     */
      createContext(): void {
          this.busyService.start();
          this.securityService.checkSection(this.meevoSecurityKeys.DATA_GIFTCARDTYPE).then(() => {
              this.busyService.stop();
              this.context = new GiftCardTypesContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService);
              this.context.activate(this.selectedItemId, null, this.asLocationId);
              this.context.deactivate = () => {
                  this.visualState = Model.MaintenanceFormVisualState.Search;
              };
              // Use translate service to populate field list
              this.context.locationFieldList =
                  [
                      { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                  ];
          }).catch(() => {
              this.busyService.stop();
          });
      }
    }

    angular.module("meevo.plugins.giftCardTypes")
        .controller("meevo.plugins.giftCardTypes.GiftCardTypesController", GiftCardTypesController);
}